/**
 * Invoice-status vocabulary for the Order Devices page.
 *
 * The column holds TWO vocabularies and that is deliberate:
 *   - rows ingested from Stripe carry Stripe's own word — `draft`, `open`, `paid`,
 *     `uncollectible`, `void` — so this page and the Stripe dashboard never disagree;
 *   - the 1,746 sheet-backfilled rows keep the words they were loaded with (PAID, UNPAID,
 *     PAST_DUE, VOIDED_RECREATED, …), because that history is not rewritten.
 *
 * So every DECISION canonicalises, and every LABEL stays verbatim. Mirrors the API's
 * `canonicalStatus()` in stripe-ingest.client.ts — change both together.
 */
export function canonStatus(status?: string | null): string {
  const v = (status || '').trim().toLowerCase();
  // UNPAID and PAST_DUE were this app's words for an invoice that is simply `open` in Stripe.
  // PAST_DUE is NOT `uncollectible`: that means written off, which is a different fact.
  if (v === 'unpaid' || v === 'past_due') return 'open';
  // The supersession itself lives in `newInvoiceId`.
  if (v === 'voided_recreated') return 'void';
  return v;
}

/** Paid in full — the only state that opens the coupon gate without an approval. */
export function isPaidStatus(status?: string | null): boolean {
  return canonStatus(status) === 'paid';
}

/** Not finalised in Stripe: no coupon, ever, and no approval unlocks it. */
export function isDraftStatus(status?: string | null): boolean {
  return canonStatus(status) === 'draft';
}
